<script setup>
import { useModalogStore } from "@/stores/modalog.js";
import BrandFooter from "./Partials/BrandFooter.vue";
import BrandToaster from "@/Components/Brand/BrandToaster.vue";
import DashboardHeader from "./Partials/DashboardHeader.vue";

const modalogStore = useModalogStore();
</script>

<template>
    <div class="brand min-h-screen bg-brand-cream font-brand text-brand-navy">
        <!--
            px-5 (not px-3) at all sizes so the card lines up with
            BrandFooter's own max-w-[1472px] + px-5 wrapper. The white page
            card closes with rounded corners and a cream gap before the
            footer (Figma 224-290 / 443-218), mirroring the header's rounded
            top.
        -->
        <div class="mx-auto max-w-[1512px] px-5 pb-5 pt-3 sm:pb-8 sm:pt-5">
            <DashboardHeader />

            <main
                class="rounded-b-[10px] border-t border-brand-tan/40 bg-white px-4 pb-10 pt-5 sm:px-9 sm:pb-14 sm:pt-7"
            >
                <slot />
            </main>
        </div>

        <BrandFooter />

        <!-- Dynamic Modalog (Create List, Add Gift, etc.) -->
        <transition name="fade" mode="in-out">
            <component
                :is="modalogStore.modalogType"
                v-bind="modalogStore.modalogProps"
            ></component>
        </transition>

        <BrandToaster />
    </div>
</template>
